
import React from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { parseHtmlForReact, stripOutHtml } from '../helpers'

const singleAxisPrintPreview = (question) => {
    const { optionSet } = question
    const elems = []

    if (optionSet.hasNumericCodes) {
        elems.push(<div className='tag numeric'>numeric</div>)
    }
    if (optionSet.isExclusive) {
        elems.push(<div className='tag exclusive'>EXCLUSIVE</div>)
    }
    if (optionSet.sortType) {
        elems.push(<div className='tag sorttype'>{optionSet.sortType}</div>)
    }
    if (optionSet.hasNumericCodes) {
        elems.push(<div className='tag numeric'>numeric</div>)
    }

    return elems
}

const readableOperatorText = (operator) => {
    switch (operator) {
        case 'AND':
            return i18n.t('print.operator.AND')
        case 'NAND':
            return i18n.t('print.operator.NAND')
        case 'OR':
            return i18n.t('print.operator.OR')
        case 'NOR':
            return i18n.t('print.operator.NOR')
        default:
            return ''
    }
}

const doubleAxisPrintPreview = (question) => {
    const { isFlipped } = question.settings.frontend
    const { optionSetY, optionSetX } = question
    const rowLabel = isFlipped ? 'Column' : 'Row'
    const colLabel = isFlipped ? 'Row' : 'Column'
    const elems = []
    if (optionSetY.sortType) {
        elems.push(<div className='tag sorttype'>{rowLabel}: {optionSetY.sortType}</div>)
    }
    if (optionSetX.sortType) {
        elems.push(<div className='tag sorttype'>{colLabel}: {optionSetX.sortType}</div>)
    }
    if (optionSetY.isExclusive) {
        elems.push(<div className='tag sorttype'>{rowLabel}: Exclusive</div>)
    }
    if (optionSetX.isExclusive) {
        elems.push(<div className='tag sorttype'>{colLabel}: Exclusive</div>)
    }
    if (optionSetX.hasNumericCodes) {
        elems.push(<div className='tag sorttype'>{colLabel}: Numeric</div>)
    }

    return elems
}

const getText = (question, option, store, parse = true) => {
    const { langcode } = store
    const { defaultLocale } = store.data.metadata
    const { initialLocale } = question

    let text = ''
    if (option.langs[langcode]) {
        ({ text } = option.langs[langcode])
    } else if (option.langs[defaultLocale]) {
        ({ text } = option.langs[defaultLocale])
    } else if (option.langs[initialLocale]) {
        ({ text } = option.langs[initialLocale])
    }

    text = store.replaceOptionMerge(text)

    // return option.langs[langcode]
    //     ? option.langs[langcode].text
    //     : option.langs[defaultLocale]
    //         ? option.langs[defaultLocale].text : ''
    return parse
        ? parseHtmlForReact(text, false)
        : text
}

const questionGetTitle = (question, store) => {
    const { langcode } = store
    const { defaultLocale } = store.data.metadata
    const { initialLocale } = question

    let text = ''
    console.log('questionGetTitle')
    const titleObj = question.content.longTitle || question.content.shortTitle
    console.log(JSON.stringify(question.content, null, 4))
    if (titleObj[langcode]) {
        ({ text } = titleObj[langcode])
    } else if (titleObj[defaultLocale]) {
        ({ text } = titleObj[defaultLocale])
    } else if (titleObj[initialLocale]) {
        ({ text } = titleObj[initialLocale])
    }

    return text
}

const questionOptionPrintPreview = (question, store) => {
    const { questionTypeCode } = question
    const elems = []

    if (['RD', 'CH', 'PC', 'TL', 'OD'].includes(questionTypeCode)) {
        elems.push(singleAxisOptionSkipLogic(question, store))
    }
    if (['TB', 'RT', 'SG'].includes(questionTypeCode)) {
        elems.push(doubleAxisOptionSkipLogic(question, store))
    }

    return elems.length > 0
        ? <div className="printQuestionTags">{elems}</div>
        : null
}

const getPrintPreview = (question, store) => {
    const { printMode, previewQuestion } = store
    let preview = null
    if (printMode) {
        preview = questionPrintPreview(question, store)
    } else if (previewQuestion) {
        preview = questionOptionPrintPreview(question, store)
    }
    return preview
}

const questionPrintPreview = (question, store) => {
    const { questionTypeCode, isLocked, isMandatory } = question
    const elems = []

    if (isMandatory) {
        elems.push(<div className='tag mandatory'>Mandatory</div>)
    }
    // if (isLocked) {
    //     elems.push(<div className='tag locked'>Locked</div>)
    // }
    if (['RD', 'CH', 'PC', 'TL', 'OD'].includes(questionTypeCode)) {
        elems.push(...singleAxisPrintPreview(question))
        elems.push(singleAxisOptionSkipLogic(question, store))
    }
    if (['TB', 'RT', 'SG'].includes(questionTypeCode)) {
        elems.push(...doubleAxisPrintPreview(question))
        elems.push(doubleAxisOptionSkipLogic(question, store))
    }

    return <div className='printQuestionTags'>{elems}</div>
}

const getSkipLogic = (question, store, showIfLogics) => {
    const { langcode } = store
    const { defaultLocale } = store.data.metadata
    const { initialLocale } = question
    const questionMap = store.data.pages.reduce((map, page) => {
        let questionMap = {}
        if (page.questions) {
            questionMap = page.questions.reduce((qMap, question) => {
                qMap[question.id] = question
                return qMap
            }, {})
        }
        return Object.assign(map, questionMap)
    }, {})
    const logic = showIfLogics.reduce((str, showIfLogic) => {
        return showIfLogic.triggerGroups.reduce((str, triggerGroup) => {
            const { interGroupLogicalOperator: additionalSkipLogicOperatorGroup } = triggerGroup
            const children = R.pathOr([], ['children'], triggerGroup).reduce((str, child) => {
                const { interGroupLogicalOperator: additionalSkipLogicOperatorChild } = child
                let logical = ''
                const triggers = child.triggers.reduce((str, trigger) => {
                    logical = trigger.interTriggerLogicalOperator
                    const { condition } = trigger
                    const { interTriggerLogicalOperator } = trigger
                    const question = questionMap[condition.pageQuestionId]
                    const { isFlipped } = question.settings.frontend
                    const isMulti = ['RT', 'TB', 'SG'].indexOf(question.questionTypeCode) > -1
                    let option
                    let option2

                    if (isMulti) {
                        const set1 = !isFlipped ? question.optionSetY : question.optionSetX
                        const set2 = !isFlipped ? question.optionSetX : question.optionSetY
                        option = set1.options.find(option => option.id === condition.set1)
                        if (condition.set2) {
                            option2 = set2.options.find(option => option.id === condition.set2)
                        }
                    } else {
                        option = question.optionSet.options.find(option => option.id === condition.set1)
                    }

                    // const option = question.sets[question.settings.frontend.alignment === 'V' ? 0 : 1].options.find(option => option.id === condition.set1)
                    // const option2 = condition.set2 ? question.sets[question.alignment === 'V' ? 1 : 0].options.find(option => option.id === condition.set2) : ''
                    let equals
                    let option1Text = ''
                    if (option) {
                        option1Text = getText(question, option, store)
                    }

                    let option2Text = ''
                    if (option2) {
                        option2Text = getText(question, option2, store)
                    }
                    if (!question.settings.frontend.isFlipped) {
                        equals = (option ? option1Text : '') + (option2 ? `_${option2Text}` : '')
                    } else {
                        equals = (option2 ? `${option2Text}_` : '') + (option ? option1Text : '')
                    }
                    if (!str) {
                        str = `Question '${stripOutHtml(questionGetTitle(question, store))}' ${readableOperatorText(interTriggerLogicalOperator)} ('${equals}'`
                    } else {
                        str += `,'${equals}'`
                    }
                    
                    return str
                }, '')
                if (str) {
                    str += ` <b>${additionalSkipLogicOperatorChild}</b> `
                }
                str += `${triggers})`
                return str
            }, '')
            if (str) {
                str += ` <b>${additionalSkipLogicOperatorGroup}</b> `
            }
            str += `<b>(</b>${children}<b>)</b>`
            return str
        }, '')
    }, '')
    return parseHtmlForReact(logic, false)
}

const doubleAxisOptionSkipLogic = (question, store) => {
    const { skipLogic } = question

    const optionHasLogic = (optionId) => (
        skipLogic && skipLogic.some(sl => sl.action.optionId === optionId)
    )

    const optionSkipLogic = (optionId) => (
        skipLogic && skipLogic.filter(sl => sl.action.optionId === optionId)
    )

    // return ''
    return <div>
        {question.optionSetY.options.filter(o => optionHasLogic(o.id)).map(o => (
            <div className="printShowIf">Row ({getText(question, o, store)}) <span>SHOWIF</span> Hidden unless: {getSkipLogic(question, store, optionSkipLogic(o.id))}</div>
        ))}
        {question.optionSetX.options.filter(o => optionHasLogic(o.id)).map(o => (
            <div className="printShowIf">Column ({getText(question, o, store)}) <span>SHOWIF</span> Hidden unless: {getSkipLogic(question, store, optionSkipLogic(o.id))}</div>
        ))}
    </div>
}

const singleAxisOptionSkipLogic = (question, store) => {
    const { skipLogic } = question

    const optionHasLogic = (optionId) => (
        skipLogic && skipLogic.some(sl => sl.action.optionId === optionId)
    )

    const optionSkipLogic = (optionId) => (
        skipLogic && skipLogic.filter(sl => sl.action.optionId === optionId)
    )

    return <div>
        {question.optionSet.options.filter(o => optionHasLogic(o.id)).map(o => (
            <div className="printShowIf">Option ({getText(question, o, store)}) <span>SHOWIF</span> Hidden unless: {getSkipLogic(question, store, optionSkipLogic(o.id))}</div>
        ))}
    </div>
}

const optionPrintPreview = (option) => {
    return (
        <span className='printOptionTags'>
            { option.hasOptionOther &&
                <i className='fal fa-question-circle'/>
            }
            { option.isLocked &&
                <i className='fal fa-lock locked'/>
            }
            { !option.isNonReporting && option.isExclusive &&
                <i className='fas fa-star exclusive'/>
            }
            { option.isNonReporting && 
                <i className='fas fa-star nonreporting'/>
            }
        </span>
    )
}

export {
    questionPrintPreview,
    questionOptionPrintPreview,
    optionPrintPreview,
    getPrintPreview,
    getText,
}
